import { z } from "zod";

const EMPTY_VALUE = "null";

export const classificationIdCodec = z.codec(
    z.string(),
    z.string().nullable(),
    {
        encode: (value) => value ?? EMPTY_VALUE,
        decode: (encString) =>
            encString === EMPTY_VALUE || encString === "" ? null : encString,
    }
);
